import { Component, OnInit, input, ViewChild, ViewEncapsulation, OnDestroy, computed, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ClientInformation } from 'src/app/models/client-information';
import { LTDataSwapRequest } from 'src/app/models/lt-dataswap-request';
import { IntegrationIdentifier } from 'src/app/models/integration-identifier';
import { ClientIntegrationService } from 'src/app/services/client-integration.service';
import { LBADataswapService } from 'src/app/services/lba-dataswap.service';
import { Integration } from 'src/app/models/integration';
import { User } from 'src/app/models/user';
import { MonacoPageComponent } from 'src/app/features/lt-shared-ui/lt-monaco/components/monaco-editor/monaco-editor.component';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { ToastService } from 'src/app/services/toast.service';
import { IdentifierService } from 'src/app/services/identifier.service';
import { IntegrationInformation } from 'src/app/models/integration-information';
import { CommonModule, DatePipe } from '@angular/common';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { LTButtonComponent } from 'src/app/features/lt-shared-ui/lt-button/components/lt-button/lt-button.component';
import { LTSwitchComponent } from 'src/app/features/lt-shared-ui/lt-button/components/lt-switch/lt-switch.component';
import { LTSpinnerComponent } from 'src/app/features/lt-shared-ui/lt-info/components/lt-spinner/lt-spinner.component';
import { DataSwapResponse } from 'src/app/models/dataswap-response';
import { GridSort } from 'src/app/features/grid/classes/grid-config.types';
const today = new Date();

@Component({
  selector: 'app-lba-dataswap',
  templateUrl: './lba-dataswap.component.html',
  styleUrls: ['./lba-dataswap.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ClientIntegrationService, LBADataswapService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    LTButtonComponent,
    LTSpinnerComponent,
    LTSwitchComponent,
    MonacoPageComponent,
  ],
})
export class LBADataswapComponent implements OnInit, OnDestroy {
  componentDestroyed$ = new Subject<boolean>();

  @ViewChild('monaco') public monaco: MonacoPageComponent;
  @ViewChild('monaco1') public monaco1: MonacoPageComponent;
  @ViewChild('monaco2') public monaco2: MonacoPageComponent;
  @ViewChild('monaco3') public monaco3: MonacoPageComponent;

  constructor(
    private identifierService: IdentifierService,
    private lbaDataswapService: LBADataswapService,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    user: User,
  ) {
    this.activeUser = user;
  }

  private sub: any;
  client = input<ClientInformation>();
  integration = input<Integration>();
  integrationIdentifiers = input<IntegrationIdentifier[]>();
  isInTab = input<boolean>(false);
  // Local mutable copy of integration for the editIntegration() reset case (non-tab mode)
  private localIntegration = signal<Integration | undefined>(undefined);
  credentialsLoaded = false;

  monacoData1 = '';
  monacoData2 = '';
  monacoData3 = '';
  displayMonaco1 = false;
  displayMonaco2 = false;
  displayMonaco3 = false;
  requestLoading = false;
  exportType = 'file';
  tabId = 0;

  loadingWorkbook = false;

  clients: ClientInformation[] = [];
  selectedClient: ClientInformation;
  clientNameList: string[];
  clientSelected: boolean;
  filteredClients: Observable<string[]>;
  clientsFiltered: Observable<ClientInformation[]>;
  clientFormControl = new UntypedFormControl();

  activeUser: User;
  selectedIntegration: Integration;
  integrationSelected: boolean;
  clientIntegrations: Integration[] = [];
  integrationsFiltered: Observable<Integration[]>;
  displayedIntegrationList: Integration[];
  integrationFormControl = new UntypedFormControl();

  destination: string;
  destinationListOptions = [];
  destinationList = [];
  destinationAllowedList = ['CSDataSwap', 'LGDataSwap'];

  destinationFormControl = new UntypedFormControl();

  fileTypeList: string[] = ['applic', 'empl', 'emplia', 'branch', 'gl'];
  fileTypeInputValue = signal<string>('applic');
  filteredFileTypeOptions = computed(() => {
    const filterValue = this.fileTypeInputValue().toLowerCase();
    return this.fileTypeList.filter(option => option.toLowerCase().includes(filterValue));
  });


  latestNo: number = 1;
  latestNoOptions = [1, 2, 3];
  latestNoOptionsGroup = [1, 2, 3];

  csDataSwapRoles: string[] = [
    'LOSTalker.Integration.CompenSafe.DataSwap',
    'LOSTalker.Integration.CompenSafe',
  ];

  lgDataSwapRoles: string[] = [
    'LOSTalker.Integration.LimeGear.DataSwap',
    'LOSTalker.Integration.LimeGear',
  ];

  loanNumber = '';

  messageGetLoan: string;
  messageGetFile: string;
  successGetLoan: boolean;
  successGetFile: boolean;

  //integrationIdentifier: IntegrationIdentifier;
  selectedIntegrationIds: IntegrationInformation[];
  selectedInfoRecord: IntegrationInformation;

  clientAndIntegrationProvided = false;

  selectByLTClient = false;

  //integrationIdentifierFullList: IntegrationIdentifier[];
  displayedIntegrationInfoList: IntegrationInformation[] = [];
  integrationInformationList: IntegrationInformation[] = [];
  integrationInfoFilteredList: Observable<IntegrationInformation[]>;
  integrationInfoListFormControl = new UntypedFormControl();
  destinationListFormControl = new UntypedFormControl();
  validDestination = false;
  loadingFinished = false;

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  ngOnInit(): void {
    this.localIntegration.set(this.integration());
    this.selectByLTClient = this.isInTab();
    if (undefined == this.client() && undefined == this.localIntegration()) {

      this.identifierService.getAllActiveIntegrationIdentifiersForDataSwap()
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe({
          next: (integrationInfo) => {
            this.integrationInformationList = integrationInfo.filter(i => i.locked == false);
            this.configureIdentifierList();
          },
          error: (_error) => {
            this.loadingFinished = true;
          },
        });
    }
    else {
      this.clients.push(this.client());
      this.clientIntegrations.push(this.localIntegration());
      if (this.integrationIdentifiers() != undefined && this.integrationIdentifiers().length > 0) {
        this.clientAndIntegrationProvided = true;
        this.resetMonaco();
        this.integrationInformationList = this.integrationIdentifiers().map(id => new IntegrationInformation(this.localIntegration(), id));
        this.configureIdentifierList();
      }
      else {
        this.clientAndIntegrationProvided = true;
        this.resetMonaco();
        this.identifierService.getIntegrationIdentifiers(this.localIntegration().integrationId)
          .pipe(takeUntil(this.componentDestroyed$))
          .subscribe({
            next: (identifiers) => {
              this.integrationInformationList = identifiers.map(id => new IntegrationInformation(this.localIntegration(), id));
              this.configureIdentifierList();
            },
            error: (_error) => {
              this.loadingFinished = true;
              this.toastService.toastCreate('Error loading integration identifiers', 'Danger', { autoClose: true, keepAfterRouteChange: false });
            },
          });
      }
    }
  }

  configureIdentifierList(): void {

    if (this.integrationInformationList.length > 0) {

      this.integrationInformationList = this.integrationInformationList.sort((a, b) => a.identifierNameValue.localeCompare(b.identifierNameValue))

      if (!this.client()) {
        this.clients = this.integrationInformationList.map(i => new ClientInformation({ losTalkerClientId: i.clientId, clientDisplayName: i.clientName, clientAbbreviatedName: '', compensafeInternalName: '', dataSourceTypeAgg: '' }));
        this.clients = this.clients.filter((v, i, a) => a.map(x => x.losTalkerClientId).indexOf(v.losTalkerClientId) === i);
      }

      if (this.destinationAllowedList.length > 0) {
        this.integrationInformationList = this.integrationInformationList.filter(x => this.destinationAllowedList.indexOf(x.destinationName) != -1);
      }

      if (!this.activeUser.checkAccess(this.csDataSwapRoles)) {
        this.integrationInformationList = this.integrationInformationList.filter(d => d.destinationName !== 'CSDataSwap');
      }
      else {
        this.destinationListOptions.push('Incentive Compensation');
      }

      if (!this.activeUser.checkAccess(this.lgDataSwapRoles)) {
        this.integrationInformationList = this.integrationInformationList.filter(d => d.destinationName !== 'LGDataSwap');
      }
      else {
        this.destinationListOptions.push('Mortgage Analytics');
      }

      this.clientsFiltered = this.clientFormControl.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this.filterClients(name) : this.clients.slice()),
      );

      this.integrationsFiltered = this.integrationFormControl.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this.filterIntegrationNames(name) : this.displayedIntegrationList.slice()),
      );

      this.integrationInfoFilteredList = this.integrationInfoListFormControl.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this.filterIntegrationIdentifierValues(name) : this.displayedIntegrationInfoList.slice()),
      );

      if (this.client()) {
        this.selectClient(this.client());
      }

      if (this.localIntegration()) {
        this.selectIntegration(this.localIntegration());
      }

      if (this.integrationInformationList.length == 1) {
        this.selectedInfoRecord = this.integrationInformationList[0];
        this.setDestinationFromDestinationName();
      }
      else if (this.destinationListOptions.length == 1) {
        this.selectDestination(this.destinationListOptions[0]);
      }
    }
    else {
      this.toastService.toastCreate('No Available Identifiers Found for DataSwap Request', 'Danger', { autoClose: true, keepAfterRouteChange: false });
    }

    this.loadingFinished = true;
  }

  updateData(event: any, index: number) {
    if (index == 1) {
      this.monacoData1 = String(event);
    }
    else if (index == 2) {
      this.monacoData2 = String(event);
    }
    else if (index == 3) {
      this.monacoData3 = String(event);
    }
  }

  // get FileType input
  getFileTypeValue(): string {
    return this.fileTypeInputValue();
  }

  // Update FileType from Input
  updateFileTypeInput(value: string) {
    this.fileTypeInputValue.set(value);
    this.resetMonaco();
  }

  // clear FileType Input Form Field
  clearFileTypeInput() {
    this.fileTypeInputValue.set('');
    this.resetMonaco();
  }

  // update FileType from dropdown
  onFileTypeOptionSelected(event: MatAutocompleteSelectedEvent) {
    const selectedValue = event.option.value;
    this.fileTypeInputValue.set(selectedValue);
    this.resetMonaco();
  }

  getIntegrations(): void {
    if (this.selectedClient) {
      const selectedIntegrations = this.integrationInformationList.filter(x => x.clientId == this.selectedClient.losTalkerClientId);
      //remove duplicate integration information records
      this.clientIntegrations = selectedIntegrations.map(i => new Integration(i));
      this.clientIntegrations = this.clientIntegrations.filter((v, i, a) => a.map(x => x.integrationId).indexOf(v.integrationId) === i);
      this.displayedIntegrationList = this.clientIntegrations;
      this.integrationsFiltered = this.integrationFormControl.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.integrationName),
        map(integrationName => integrationName ? this.filterIntegrationNames(integrationName) : this.displayedIntegrationList.slice()),
      );
    }
    else {
      const s = 'Invalid Client.';
      this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
      this.selectedInfoRecord = null;
    }


  }

  setDestinationFromDestinationName() {
    if (this.selectedInfoRecord?.destinationName == 'LGDataSwap') {
      this.destination = 'Mortgage Analytics';
    }
    else if (this.selectedInfoRecord?.destinationName == 'CSDataSwap') {
      this.destination = 'Incentive Compensation';
    }
    else {
      const s = 'Invalid destination.';
      this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
    }
  }

  navigateToPushBack(): void {

    if (this.selectedInfoRecord != null)
    {
      var parts = ['/client-pushbacks'];
      parts.push(this.selectedInfoRecord.destinationName);
      parts.push(this.selectedInfoRecord.clientInformationId);
      parts.push(this.selectedInfoRecord.identifierIdValue);
      parts.push(this.selectedInfoRecord.identifierNameValue);
      this.router.navigate(parts);
    }
  }

  validToShowPushBack(): boolean {
    let validRequest = true;

    if (this.selectedClient == null && this.selectByLTClient) {
      validRequest = false;
    }
    else if (this.selectedIntegration == null && this.selectByLTClient) {
      validRequest = false;
    }
    else if (this.selectedInfoRecord == null) {
      validRequest = false;
    }
    else if (this.destination == null) {
      validRequest = false;
    }
    else if (!this.activeUser.checkAccess(this.csDataSwapRoles) && !this.activeUser.checkAccess(this.lgDataSwapRoles)) {
      validRequest = false;
    }

    return validRequest;
  }

  selectIdentifier(i: IntegrationInformation): void {
    this.selectedInfoRecord = i;
    if (this.selectedInfoRecord.identifierKeyValue == undefined) {
      this.identifierService.getIntegrationIdentifierByIntegrationAndDestinationId(this.selectedInfoRecord.integrationId, this.selectedInfoRecord.destinationId)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(data => {
          this.selectedInfoRecord.identifierKeyValue = data.identifierKeyValue;
          this.setDestinationFromDestinationName();
          this.resetMonaco();
          this.credentialsLoaded = true;
        });
    }
    else {
      this.setDestinationFromDestinationName();
      this.resetMonaco();
      this.credentialsLoaded = true;
    }
  }

  selectDestination(d: string) {
    this.selectedInfoRecord = undefined;
    this.destination = d;
    let dest;
    if (this.destination == 'Mortgage Analytics') {
      dest = 'LGDataSwap';
    }
    else if (this.destination == 'Incentive Compensation') {
      dest = 'CSDataSwap';
    }

    if (!this.integrationInfoListFormControl.value != this.integrationInfoListFormControl.defaultValue) {
      this.integrationInfoListFormControl.setValue('');
    }

    this.integrationInformationList = this.integrationInformationList.sort((a, b) => a.identifierNameValue.localeCompare(b.identifierNameValue))

    this.displayedIntegrationInfoList = this.integrationInformationList.filter(ii => ii.destinationName == dest);

    if (this.integrationInfoListFormControl.value != this.integrationInfoListFormControl.defaultValue) {

      this.integrationInfoFilteredList = this.integrationInfoListFormControl.valueChanges.pipe(
        startWith(''),
        map(value => (value != undefined && typeof value === 'string') ? value : value.name),
        map(name => name ? this.filterIntegrationIdentifierValues(name) : this.displayedIntegrationInfoList.slice()),
      );
    }

    this.validDestination = true;
  }

  selectClient(c: ClientInformation) {
    this.resetMonaco();
    this.selectedClient = c;
    this.clientSelected = true;
    this.selectedIntegration = null;
    this.getIntegrations();
  }

  selectIntegration(i: Integration) {
    this.resetMonaco();
    this.selectedIntegration = i;
    this.integrationSelected = true;
    this.integrationInformationList = this.integrationInformationList.sort((a, b) => a.identifierNameValue.localeCompare(b.identifierNameValue))
    this.displayedIntegrationInfoList = this.integrationInformationList.filter(ii => ii.integrationId == this.selectedIntegration.integrationId);
    if (this.displayedIntegrationInfoList.length == 1) {
      this.selectIdentifier(this.displayedIntegrationInfoList[0]);
    }
    else {
      if (this.integrationInfoListFormControl.value != this.integrationInfoListFormControl.defaultValue) {

        this.integrationInfoFilteredList = this.integrationInfoListFormControl.valueChanges.pipe(
          startWith(''),
          map(value => (value != undefined && typeof value === 'string') ? value : value.name),
          map(name => name ? this.filterIntegrationIdentifierValues(name) : this.displayedIntegrationInfoList.slice()),
        );
      }
    }
  }

  editClient() {
    this.clearVars();
  }

  onTabSelect() {
    this.clearVars();
  }

  onFileTabSelect(e) {
    this.tabId = e.index;
  }
    
  clearVars() {
    if (undefined == this.client() && undefined == this.localIntegration()) {
      if (!this.destinationListFormControl.value != this.destinationListFormControl.defaultValue) {
        this.destinationListFormControl.setValue('');
      }
      this.destination = null;
      this.selectedClient = null;
      this.clientSelected = false;
      this.selectedIntegration = null;
      this.integrationSelected = false;
    }

    this.monacoData1 = '';
    this.monacoData2 = '';
    this.monacoData3 = '';
    this.integrationFormControl.setValue('');
    this.clientFormControl.setValue('');
    this.integrationInfoListFormControl.setValue('');
    this.displayMonaco1 = false;
    this.displayMonaco2 = false;
    this.displayMonaco3 = false;
    this.tabId = 0;
    this.loanNumber = '';

    if (this.integrationInformationList?.length != 1) {
      this.selectedInfoRecord = null;
    }

    if (this.destinationListOptions.length > 1) {
      this.validDestination = false;
      this.destination = '';
    }
  }

  editIntegration() {
    this.localIntegration.set(null);
    this.integrationSelected = false;

    this.monacoData1 = '';
    this.monacoData2 = '';
    this.monacoData3 = '';
    this.integrationFormControl.setValue('');
    this.integrationInfoListFormControl.setValue('');
    this.displayMonaco1 = false;
    this.displayMonaco2 = false;
    this.displayMonaco3 = false;

    if (this.integrationInformationList?.length != 1) {
      this.selectedInfoRecord = null;
    }
  }

  editDestination() {
    this.destination = '';
    this.selectedInfoRecord = null;
  }

  resetMonaco() {
    this.displayMonaco1 = false;
    this.displayMonaco2 = false;
    this.displayMonaco3 = false;
    this.monacoData1 = '';
    this.monacoData2 = '';
    this.monacoData3 = '';
  }

  convertToIdentifier(info: IntegrationInformation): IntegrationIdentifier {
    const identifier: IntegrationIdentifier = {
      integrationId: info.integrationId,
      destinationId: info.destinationId,
      destinationName: info.destinationName,
      identifierIdValue: info.identifierIdValue,
      identifierNameValue: info.identifierNameValue,
      identifierKeyValue: info.identifierKeyValue,
      createdDate: info.identifierCreatedDate,
      updatedDate: info.identifierUpdatedDate,
      canFastFetch: info.canFastFetch,
      canDataSwap: info.canDataSwap,
      subscriptionName: info.subscriptionName,
      isMABase: info.isMABase,
      isMABaseCustom: info.isMABaseCustom,
    };

    return identifier;
  }

  getIntegrationWorkbook() {
    this.loadingWorkbook = true;
    if (this.selectedInfoRecord == undefined) {
      this.toastService.toastCreate('No Identifier Selected', 'Danger', { autoClose: true, keepAfterRouteChange: false });
      return;
    }

    this.identifierService.generateIntegrationWorkbook(this.convertToIdentifier(this.selectedInfoRecord))
      .subscribe(blob => {
        this.identifierService.downloadExcelResult(blob, this.convertToIdentifier(this.selectedInfoRecord));
        this.loadingWorkbook = false;
      });
  }

  submitDataSwapRequest(exType: string) {
    this.requestLoading = true;
    this.displayMonaco1 = false;
    this.displayMonaco2 = false;
    this.displayMonaco3 = false;

    this.exportType = exType;
    if (!this.validateRequestFields()) {
      this.successGetFile = false;
      return;
    }

    const ft = this.getFileTypeValue();
    this.successGetFile = true;

    const dataSwapParams = new LTDataSwapRequest();
    if(this.selectedInfoRecord == undefined || this.selectedInfoRecord.identifierIdValue == '') {
      this.toastService.toastCreate(`Identifier Not Correctly Selected for ${this.destination} DataSwap Request`, 'Danger', { autoClose: true, keepAfterRouteChange: false });
      this.requestLoading = false;
      return;
    }

    dataSwapParams.clientShortName = this.selectedInfoRecord.identifierNameValue;
    dataSwapParams.clientId = +this.selectedInfoRecord.identifierIdValue;
    dataSwapParams.fileType = ft;
    dataSwapParams.loanNo = this.loanNumber;
    dataSwapParams.latestNo = this.latestNo;
    dataSwapParams.swapKey = this.selectedInfoRecord.identifierKeyValue;
    if (this.destination == 'Mortgage Analytics') {
      dataSwapParams.dataSwapType = 'Liverpool';
    }
    else if (this.destination == 'Incentive Compensation') {
      dataSwapParams.dataSwapType = 'London';
    }
    
    this.lbaDataswapService.submitDataSwapRequest(dataSwapParams)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: (value) => {
          this.parseDataSwapResponse(dataSwapParams, value); 
        },
        error: (_error) => {
          this.toastService.toastCreate('DataSwap Request Failed: ' + dataSwapParams.clientId, 'Danger',
              { autoClose: true, keepAfterRouteChange: false },
          );
        },
        complete: () => {
          this.requestLoading = false;
        }
      });
    }

  private parseDataSwapResponse(request: LTDataSwapRequest, response: DataSwapResponse[]) {
    if (response != null && response.length > 0) {
        this.monacoData1 = '';
        this.monacoData2 = '';
        this.monacoData3 = '';

        if(response.length > 0){
            this.monacoData1 = response[0].responseElement;
            this.displayMonaco1 = true;
            if(response.length > 1){
                this.monacoData2 = response[1].responseElement;
                this.displayMonaco2 = true;
            }

            if(response.length > 2){
                this.monacoData3 = response[2].responseElement;
                this.displayMonaco3 = true;
            }
        }
        else{
          this.toastService.toastCreate('No DataSwap Results Found For: ' + request.clientId, 'Danger',
              { autoClose: true, keepAfterRouteChange: false },
          );
        }
    }
  }

  validateRequestFields(): boolean {
    let validRequest = true;
    const ft = this.getFileTypeValue();

    this.setDestinationFromDestinationName();
    let s = '';
    if (this.selectedClient == null && this.selectByLTClient) {
      s = 'Invalid Client';
      this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
      validRequest = false;
    }
    else if (this.selectedIntegration == null && this.selectByLTClient) {
      s = 'Invalid Integration';
      this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
      validRequest = false;
    }
    else if (this.selectedInfoRecord == null) {
      s = 'Invalid Identifier';
      this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
      validRequest = false;
    }
    else if (ft == null || ft == '') {
      s = 'File Type cannot be blank.';
      this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
      validRequest = false;
    }
    else if (this.latestNo == null) {
        s = 'Latest No cannot be blank.';
        this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
        validRequest = false;
    }
    else if (this.destination == null) {
      s = 'Destination cannot be blank.';
      this.toastService.toastCreate(s, 'Danger', { autoClose: true, keepAfterRouteChange: false });
      validRequest = false;
    }

    return validRequest;
  }

  changeSelectionMethod() {
    this.clearVars();

    if (this.selectByLTClient) {
      this.integrationsFiltered = this.integrationFormControl.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this.filterIntegrationNames(name) : this.displayedIntegrationList.slice()),
      );
    }
    else {
      this.integrationInfoFilteredList = this.integrationInfoListFormControl.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this.filterIntegrationIdentifierValues(name) : this.displayedIntegrationInfoList.slice()),
      );
    }
  }

  displayFnClient(x: ClientInformation): string {
    return x && x.clientDisplayName ? x.clientDisplayName : '';
  }

  displayFnIntegration(x: IntegrationInformation): string {
    return x && x.integrationName ? x.integrationName : '';
  }

  displayFnIdentifier(x: IntegrationInformation): string {
    return x && x.identifierNameValue && x.identifierIdValue ? x.identifierIdValue + ' - ' + x.identifierNameValue + (x.dataSourceType ? ' - ' + x.dataSourceType : ''): '';
  }

  private filterClients(name: string): ClientInformation[] {
    const filterValue = name.toLowerCase();
    return this.clients.filter(option => option.clientDisplayName.toLowerCase().includes(filterValue));
  }

  private filterIntegrationNames(name: string): Integration[] {
    const filterValue = name.toLowerCase();
    return this.displayedIntegrationList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  private filterIntegrationIdentifierValues(name: string): IntegrationInformation[] {
    if (name == undefined) {
      return this.displayedIntegrationInfoList;
    }

    const filterValue = name.toLowerCase();
    return this.displayedIntegrationInfoList.filter(option => option.identifierNameValue.toLowerCase().includes(filterValue) || option.identifierIdValue.toLowerCase().includes(filterValue));
  }


  setLoanNumber(loanNumber: string): void {
    this.loanNumber = loanNumber;
    this.resetMonaco();
  }

  public checkAccess(role: string[]): boolean {
    if (this.activeUser.checkAccess(role)) {
      return true;
    } else {
      return false;
    }
  }

  saveFile(): void {
    if (this.tabId == 0 &&  this.displayMonaco1 && this.monacoData1 != '' && this.monaco1 != undefined) {
      this.processSaveFile(1, this.monacoData1);
    }

    if (this.tabId == 1 && this.displayMonaco2 && this.monacoData2 != '' && this.monaco2 != undefined) {
      this.processSaveFile(2, this.monacoData2);
    }

    if (this.tabId == 2 &&  this.displayMonaco3 && this.monacoData3 != '' && this.monaco3 != undefined) {
      this.processSaveFile(3, this.monacoData3);
    }
  }  

  saveAllFiles(): void {
    if (this.displayMonaco1 && this.monacoData1 != '') {
      this.processSaveFile(1, this.monacoData1);
    }

    if (this.displayMonaco2 && this.monacoData2 != '') {
      this.processSaveFile(2, this.monacoData2);
    }

    if (this.displayMonaco3 && this.monacoData3 != '') {
      this.processSaveFile(3, this.monacoData3);
    }
  }

  processSaveFile(editor = 1, data = '') {
    let fileName = '';
    const ft = this.getFileTypeValue();

    if (!this.selectByLTClient) {
      let clientName = this.selectedInfoRecord.identifierNameValue;
      clientName = clientName.replace(/[^a-zA-Z0-9_-]/g, '');
      fileName += clientName;
    }
    else {
      let clientName = this.selectedClient.clientAbbreviatedName;
      clientName = clientName.replace(/[^a-zA-Z0-9_-]/g, '');
      fileName += clientName;
    }

    if (this.exportType == 'loan') {
      fileName += '-loan-' + this.loanNumber;

    }
    else if (this.exportType == 'file') {
      fileName += '-' + ft;
    }

    const datepipe: DatePipe = new DatePipe('en-us');
    const formattedDate = datepipe.transform(today, 'yyyyMMddHHmmssZ');
    fileName += '-' + editor + '-' + formattedDate + '.xml';

    const blob = new Blob([data], { type: 'application/xml' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute("download", fileName)
    link.click(); 

    this.toastService.toastCreate('File saved to Downloads. Filename: ' + fileName, 'Info', { autoClose: true, keepAfterRouteChange: false });
  }

}
